import { CmsApiImageGalleryBlockData } from 'modules/cms/api/types/CmsApiImageGallery';
import { CmsAmpCardsBlock } from 'modules/cms/blocks/Amp/Cards';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpImageGalleryBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiImageGalleryBlockData>) {
  return (
    <CmsAmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        imageSize: 'LARGE',
        cards: data.images.map((image) => ({
          image,
        })),
        seeMoreText: getText('See All Images'),
      }}
    />
  );
}
